import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as r } from "../chunks/tslib.es6.js";
import t from "./Accessor.js";
import { assumeNonNull as s } from "./maybe.js";
import e from "./accessorSupport/MultiOriginStore.js";
import { idToName as o, nameToId as i } from "./accessorSupport/PropertyOrigin.js";
import { read as n } from "./accessorSupport/read.js";
import { getProperties as c } from "./accessorSupport/utils.js";
import { subclass as p } from "./accessorSupport/decorators/subclass.js";

var a = function a(t) {
  var a = /*#__PURE__*/function (_t) {
    _inherits(a, _t);

    var _super = _createSuper(a);

    function a() {
      var _this;

      _classCallCheck(this, a);

      for (var _len = arguments.length, r = new Array(_len), _key = 0; _key < _len; _key++) {
        r[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(r));
      var t = s(c(_assertThisInitialized(_this))),
          o = t.metadatas,
          i = t.store,
          n = new e();
      t.store = n, i.keys().forEach(function (r) {
        n.set(r, i.get(r), 0);
      }), Object.keys(o).forEach(function (r) {
        t.internalGet(r) && n.set(r, t.internalGet(r), 0);
      });
      return _this;
    }

    _createClass(a, [{
      key: "read",
      value: function read(r, t) {
        n(this, r, t);
      }
    }, {
      key: "getAtOrigin",
      value: function getAtOrigin(r, t) {
        var s = u(this),
            e = i(t);
        if ("string" == typeof r) return s.get(r, e);
        var o = {};
        return r.forEach(function (r) {
          o[r] = s.get(r, e);
        }), o;
      }
    }, {
      key: "originOf",
      value: function originOf(r) {
        return o(this.originIdOf(r));
      }
    }, {
      key: "originIdOf",
      value: function originIdOf(r) {
        return u(this).originOf(r);
      }
    }, {
      key: "revert",
      value: function revert(r, t) {
        var s = u(this),
            e = i(t),
            o = c(this);
        var n;
        n = "string" == typeof r ? "*" === r ? s.keys(e) : [r] : r, n.forEach(function (r) {
          o.invalidate(r), s.revert(r, e), o.commit(r);
        });
      }
    }]);

    return a;
  }(t);

  return a = r([p("esri.core.ReadOnlyMultiOriginJSONSupport")], a), a;
};

function u(r) {
  return c(r).store;
}

var f = /*#__PURE__*/function (_a) {
  _inherits(f, _a);

  var _super2 = _createSuper(f);

  function f() {
    _classCallCheck(this, f);

    return _super2.apply(this, arguments);
  }

  return f;
}(a(t));

f = r([p("esri.core.ReadOnlyMultiOriginJSONSupport")], f);
export { a as ReadOnlyMultiOriginJSONMixin, f as ReadOnlyMultiOriginJSONSupport };